import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import Swal from "sweetalert2";
import {withTourGuide} from "../../guideComponent/withTourGuide";

class EditInventarisTerm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            prosesSimpan: false
        }
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
    }

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        if (typeof showGuide !== 'function') return;
        showGuide(target, config);
    };

    handleEdit = () => {
        this.setState({ prosesSimpan: true})
        let form = {
            inv_term_id : this.props.data.inv_term_id,
            inv_term_name: this.props.data.inv_term_name,
        }
        this.props.request("inventaris_term/edit", form, 'POST')
            .then((response) => {
                if (response && response.success) {
                    this.props.changeState({
                        modal_edit: false,
                        data: [],
                    }, () => this.props.loadData())
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                } else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({ prosesSimpan: false})
                this.props.clear()
            })
    }

    render() {
        const isRange = this.props.isRange === true
        return (
            <Modal isOpen={this.props.modal_edit} toggle={this.props.clear} style={{ maxWidth: "1000px"}} zIndex={999}>
                <ModalHeader className="modal-header-ipresens" toggle={this.props.clear}>
                    <div className='modal-header-ipresens'>Edit Istilah Inventaris</div>
                </ModalHeader>
                <ModalBody className="inventaris-modal-body">
                    <div className="row p-3">
                        <div className="col">
                            <div className="form-group">
                                <div className="row">
                                    <div className="col">
                                        <label className="pengumuman-label-input" htmlFor="exampleFormControlInput1">
                                            Nama Istilah Inventaris
                                        </label>
                                        <input name="inv_term_name" className="form-control col-xl-12 col-md-12"
                                               placeholder="Masukkan nama istilah inventaris"
                                               type="text" required="" value={this.props.data.inv_term_name}
                                               onChange={this.props.handleChange}
                                               onPointerEnter={(e) => {
                                                   this.triggerGuideOnce(e, {
                                                       key: "namaIstilahInventarisEdit",
                                                       title: "Nama Istilah Inventaris",
                                                       content: "Masukkan nama istilah inventaris yang akan digunakan dalam sistem."
                                                   });
                                               }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="inventaris-modal-footer">
                    <button onClick={this.props.clear}
                            className='btn text-capitalize batalkan-add-jamker'>Batal</button>
                    <button className='btn btn-primary text-capitalize' disabled={this.state.prosesSimpan}
                            style={{padding: "8px 14px", fontWeight: 500, fontSize: "14px", lineHeight: "24px"}}
                            onClick={this.handleEdit}>{this.state.prosesSimpan ? "Menyimpan" : "Simpan"}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default withTourGuide(EditInventarisTerm);
